import { Component, OnInit } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { PostEntity } from 'src/app/models/post.model';
import { PostService } from 'src/app/services/posts/post.service';

@Component({
  selector: 'app-blog',
  templateUrl: './blog.component.html',
  styleUrls: ['./blog.component.css'],
})
export class BlogComponent implements OnInit {
  allPosts: PostEntity[] = [];
  posts: PostEntity[] = [];
  isLoading = false;
  error: string | null = null;
  selectedTag: string | null = null;

  constructor(
    private readonly postService: PostService,
    private readonly afAuth: AngularFireAuth
  ) {}

  ngOnInit(): void {
    this.afAuth.idToken.subscribe({
      next: () => this.loadPosts(),
      error: () => this.loadPosts(),
    });
  }

  loadPosts(): void {
    this.isLoading = true;
    this.postService.getPosts({ pageSize: 12 }).subscribe({
      next: (response) => {
        this.allPosts = response?.posts ?? [];
        this.applyFilter();
      },
      error: (err) => {
        console.error('Failed to load posts', err);
        this.error = 'Unable to load posts right now.';
      },
      complete: () => {
        this.isLoading = false;
      },
    });
  }

  onTagSelected(tag: string | null): void {
    this.selectedTag = tag;
    this.applyFilter();
  }

  private applyFilter(): void {
    if (!this.selectedTag) {
      this.posts = [...this.allPosts];
      return;
    }

    this.posts = this.allPosts.filter((post) => {
      return (
        post.topics &&
        Array.isArray(post.topics) &&
        post.topics.some(
          (topic) => topic && topic.trim().toLowerCase() === this.selectedTag?.toLowerCase()
        )
      );
    });
  }

  trackByPostId(_: number, post: PostEntity): string {
    return post.id;
  }
}
